import { AuthService } from '@app/core/auth/auth.service';
import { AppState } from '@app/store/states/app.state';
import { lastValueFrom, of, tap } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const initFactory = (authService: AuthService, appState: AppState) => () =>
  lastValueFrom(
    authService.authenticated().pipe(
      tap((value) => (appState.authenticated = Boolean(value))),
      tap(() => (appState.availableLanguages = ['en', 'de'])),
      catchError((err) => of(err))
    )
  );
